<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar page-nav">
      <template #left>
        <van-icon name="arrow-left" class="nav-back" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="page-body">
    <div class="items">
      <div
        class="item"
        @click="changeLang('zh', $event)"
      >
        <div class="flex_center">
          
          <div class="info">簡體中文</div>
        </div>
        <div v-if="lang == 'zh'" class="check">✓</div>
      </div>
      <div
        class="item"
        @click="changeLang('en', $event)"
      >
        <div class="flex_center">
        
          <div class="info">English</div>
        </div>
        <div v-if="lang == 'en'" class="check">✓</div>
      </div>
       <div
        class="item"
        @click="changeLang('ja', $event)"
      >
        <div class="flex_center">
        
          <div class="info">日本語</div>
        </div>
        <div v-if="lang == 'ja'" class="check">✓</div>
      </div>

      <div
        class="item"
        @click="changeLang('kr', $event)"
      >
        <div class="flex_center">
       
          <div class="info">한국어</div>
        </div>
        <div v-if="lang == 'kr'" class="check">✓</div>
      </div> 
    </div>
    </div>
  </div>
</template>
  
  <script>


import { Toast } from "vant";
export default {
  name: "Language",
  data() {
    return {
      lang: this.$i18n.locale || "ja",
      source: ''
    };
  },
    created() {
    this.replaceLang()
  },
  mounted() {
    this.source=this.$route.params.type
  },
  methods: {
    back(){
      return window.history.back();
    },
    replaceLang() {
      this.$http({
        method: "get",
        url: "replaceLang",
        data: {
          lang: this.lang,
        },
      }).then(() => {});
    },
    changeLang(lang) {
      
      Toast.loading({
        // mask: true,
        duration: 200,
      });
      this.lang = lang;
      this.$i18n.locale = lang;
      this.replaceLang()
      localStorage.setItem("lang", lang);
      localStorage.setItem("lang_preferred", "1");
   
      if (this.source=='setting'){
        this.$router.push({path:'/'});
      }else{
        this.$router.go(-1);
      }
    },
    }

};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container {
  min-height: 100%;
  background: #f5f5f5;
}

.page-body {
  padding: 10px 16px 0;
}

.items {
  background-color: #fff;
  font-size: 30px;
  color: #000;
}

.item {
  padding: 30px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ededed;
}

.item:last-child {
  border-bottom: none;
}

.flex_center {
  display: flex;
  align-items: center;
}

.info {
  color: #000;
}

.check {
  color: #6667e8;
  font-size: 34px;
  font-weight: 700;
}

.flex_center img {
  width: 60px;
  height: 60px;
  margin-right: 20px;
}

.nav-back {
  color: #8795ad;
}

::v-deep .page-nav {
  background: #fff;
}

::v-deep .page-nav .van-nav-bar__title {
  color: #000;
}

::v-deep .page-nav::after {
  border-bottom: 1px solid #ededed;
}
</style>
